import { ModalContext } from '@shared/context/ModalContext';
import { useContext } from 'react';


export const useModal = (name) => {
	const { state, dispatch } =  useContext(ModalContext);

  const open = (params) => {
    dispatch({ type: 'OPEN_MODAL', payload: params, name });
  };

  const close = () => {
    dispatch({ type: 'CLOSE_MODAL' });
  };

  return {
    isOpen: state.isOpen && state.modalName === name,
    modalParams: state.modalParams,
    open,
    close,
  };
};